module.exports = __webpack_public_path__ + "23a549c997070811d98531c862a99d1c.svg";